import { FC } from 'react';

import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import styles from './Password.module.scss';

const nameSpace = 'userRoleEditor.password';

interface PasswordViewProps {
    maskedPassword: string | null;
    onEdit: () => void;
}

const PasswordView: FC<PasswordViewProps> = ({
    maskedPassword,
    onEdit,
}) => {
    const { t } = useTranslation();

    return (
        <>
            <span className={styles['password-text']}>
                {maskedPassword || t(`${nameSpace}.noPassword`)}
            </span>
            <Button
                type="link"
                className={styles['edit-button']}
                onClick={onEdit}
            >
                <EditOutlined />
            </Button>
        </>
    );
};

export default PasswordView;
